import { categoryIndex, topicCollections } from '@/mocks/news';

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-900',
  secondary: 'bg-secondary-100 text-secondary-900',
};

export default function IndexSection() {
  return (
    <section id="index" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto py-10 md:py-14">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div>
              <span className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-secondary-700">
                <span className="w-6 h-px bg-secondary-400"></span>
                索引 · 合集
              </span>
              <h4 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                <a href="#index" className="hover:text-secondary-700 transition-colors cursor-pointer">
                  按条目索引，一眼挑到想追的那条线
                </a>
              </h4>
            </div>
            <p className="max-w-md text-sm text-foreground-600 leading-relaxed">
              黑料网1更新页把散落的条目按栏目归档，先看索引再决定深挖哪一条，比从头翻快得多。
            </p>
          </div>

          {/* 索引方格 */}
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {categoryIndex.map((cat) => (
              <a
                key={cat.name}
                href="#headline"
                className="group flex items-center justify-between gap-3 rounded-lg bg-background-50 border border-background-200 px-4 py-4 hover:border-secondary-300 transition-colors cursor-pointer"
              >
                <span className="flex flex-col">
                  <span className="text-sm font-medium text-foreground-900 group-hover:text-secondary-700">
                    {cat.name}
                  </span>
                  <span className="mt-1 text-xs text-foreground-500">{cat.count} 条在更</span>
                </span>
                <span
                  className={`w-9 h-9 flex items-center justify-center rounded-md text-base ${toneMap[cat.tone]}`}
                >
                  <i className="ri-hashtag" aria-hidden="true"></i>
                </span>
              </a>
            ))}
          </div>

          {/* 合集快捷入口 */}
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <span className="text-xs text-foreground-500">正在追的合集：</span>
            {topicCollections.map((topic) => (
              <a
                key={topic.id}
                href="#topic"
                className="inline-flex items-center gap-2 h-9 px-3 rounded-full bg-background-50 border border-background-200 text-xs text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bookmark-2-line text-accent-600" aria-hidden="true"></i>
                {topic.name}
                <span className="text-foreground-400">{topic.count}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}